<template>
  <div class="page_error">
    <div>
      <v-icon class="error_icon">sentiment_very_dissatisfied</v-icon>
    </div>
    <div class="error_text">
      <h1>404</h1>
      <h3>Pagina não encontrada</h3>
      <p>A página que você está procurando não existe. Vá até <a href="http://siged.ipatinga.mg.gov.br">siged.ipatinga.mg.gov.br</a> para escolher um novo caminho.</p>
    </div>
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">

</style>
